import { IApplicationState } from 'reduxStore/types';

export const getUserSetsList = (state: IApplicationState) => state.userSets.list;
export const getUserSetsListIdle = (state: IApplicationState) => state.userSets.isIdle;
export const getUserSetEditorState = (state: IApplicationState) => state.userSets.editor;
export const getIsUserSetEditorOpen = (state: IApplicationState) => getUserSetEditorState(state).show;
export const getUserSetInEdit = (state: IApplicationState) => getUserSetEditorState(state).currentSet;
export const getUserSetEditorModelsToAdd = (state: IApplicationState) => getUserSetEditorState(state).modelsToAdd;
export const getUserSetEditorHasPrevPath = (state: IApplicationState) => getUserSetEditorState(state).hasPrevPath;
